export default {
    url: '/add',
    template: '<courses-rooms-add room="vm.room"/>',
    controller (RoomResource) {
        this.room = new RoomResource();
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/courses/rooms/add/index.js